<template>
    <v-date-picker
        class="calendar"
        title-position="left"
        v-model="dateModel"
        :themeStyles="themeStyles"
        :calendarOptions="calendarOptions"
        :formats="formats"
        :available-dates="availableDateModel"
        :disabled-dates="disabledDates"
        mode="multiple"
        is-inline
    />
</template>

<script>
  import {mapActions, mapGetters, mapState} from 'vuex'

  export default {
    name: "ScheduleFilterCalendar",
    data() {
      return {
        calendarOptions: [
          {
            key: 'today',
            dates: new Date()
          }
        ],
        themeStyles: {
          wrapper: {
            background: 'transparent',
            border: '0',
          },
          dayContent: {
            borderRadius: '50%',
          }
        },
        formats: {
          title: 'MMMM YYYY',
          weekdays: 'WW',
          navMonths: 'MMM',
          input: ['l', 'YYYY-MM-DD', 'YYYY/MM/DD'],
          dayPopover: 'YYYY-MM-DD',
          data: ['l', 'YYYY-MM-DD', 'YYYY/MM/DD']
        },
        dateNow: new Date(),
        disabledDates: false
      }
    },
    computed: {
      ...mapState([
        'filterDate',
        'filterSearch',
        'urlDate',
        'availableDate',
        'startAvailableDate'
      ]),
      ...mapGetters([
        'getFormatsDate',
        'getFilteredScheduleListByDate',
        "getFilteredScheduleListBySearchAndDate"
      ]),
      dateModel: {
        get() {
          return this.filterDate.map(item => new Date(item));
        },
        set(value) {
          if (value) {
            value = value.map(item => item.getTime());
            this.setFilterDateModel(value)
          }
        }
      },
        availableDateModel() {
            if (this.filterSearch) {
                if (this.availableDate.length) {
                    this.disabledDates = false;
                    return this.availableDate;
                } else {
                    this.disabledDates = {}
                }
            } else {
                if (this.startAvailableDate.list.length) {
                    this.disabledDates = false;
                    return this.startAvailableDate.list
                } else {
                    this.disabledDates = {}
                }
            }
        }
    },
    created() {
        if (this.urlDate.date) {
        this.setFilterDateModel(this.urlDate.date.map(item => Number(item)));
      } else {
        let date = new Date();
        let year = date.getFullYear();
        let month = date.getMonth();
        let day = date.getDate();
        const dateNow = this.startAvailableDate.list.length ? [new Date(this.startAvailableDate.list[0]).getTime()] : [new Date(year, month, day).getTime()];
        this.setFilterDateModel(dateNow)
      }
    },
    methods: {
      ...mapActions([
        'setFilterDateModel'
      ]),
    }
  }
</script>

<style lang="scss"
       scoped>
    @import "~v-calendar/lib/v-calendar.min.css";

    .calendar {
        margin-bottom: 20px;

        &::v-deep {

            * {
                font-family: 'Roboto', 'Arial';
            }

            .c-pane {
                margin: 0 -10px;
            }

            .c-title {
                font-size: 16px !important;
                text-transform: capitalize;
            }

            .c-arrow-layout svg * {
                fill: #747C8F;
            }

            .c-weekdays {
                padding: 0;
            }

            .c-weekday {
                font-size: 16px;
                font-weight: 300;
                text-transform: uppercase;
                color: #747C8F;
            }

            .c-weeks {
                padding: 5px 0 7px;;
            }

            .c-day {
                min-height: 37px;
            }

            .c-day-content {
                width: 37px;
                height: 37px;
                font-size: 16px;
            }

            .c-day-background {
                width: 37px !important;
                height: 37px !important;
                background-color: #FF6633 !important;
            }
        }
    }

</style>
